import { CSSProperties, memo } from 'react'

import { RevenueImpactDeal, parseDealAmount } from '../utils'
import styles from './DealsChart.module.scss'

interface DealsChartProps {
  deals: RevenueImpactDeal[]
}

function DealsChart({ deals }: DealsChartProps) {
  const sum = deals.reduce((acc, deal) => acc + parseDealAmount(deal.amount), 0)

  return (
    <div className={styles.root}>
      {deals.map((deal, index, deals) => {
        const prevDealsSum = deals.slice(0, index).reduce((acc, deal) => acc + parseDealAmount(deal.amount), 0)
        const borderRadiusOffset = 1

        return (
          <div
            key={deal.id}
            className={styles.impact}
            style={
              {
                width: `${(100 / sum) * parseDealAmount(deal.amount) + borderRadiusOffset}%`,
                left: `${(100 / sum) * prevDealsSum}%`,
                zIndex: index,
                backgroundColor: deal.color,
              } as CSSProperties
            }
          />
        )
      })}
    </div>
  )
}

export default memo(DealsChart)
